import { useMsal } from "@azure/msal-react";
import { Button } from "react-bootstrap";
import {
  getMsalSimDocumentsInstance,
  getMsalSimInstance,
} from "../../authentication/authConfig";

export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    getMsalSimDocumentsInstance().logoutRedirect();
    getMsalSimInstance().logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    window.location.reload();
  };

  return (
    <>
      <Button className="custom-margin" onClick={() => handleLogout()}>
        Sign out
      </Button>
    </>
  );
};
